import React from 'react';
import ReactDOM from 'react-dom';
import _ from "lodash";

import SocialGrid3 from './SocialGrid3';
import StateFactory from '../StateFactory';
import SocialGrid3State from "./SocialGrid3State";
import ScreenService from "../../services/ScreenService";
import HwFeatureService from '../../services/HwFeatureService';
class SocialGrid3SmallState extends SocialGrid3State {
    get name() {
        return 'socialgrid3small';
    }

    _render(resolve) {
        ReactDOM.render(
            <SocialGrid3
                content={this.state.state.contentArr}
                onMounted={this.onSocialGridMounted}
                playing={false}
                onError={this.raiseError}
                duration={this.state.duration}
                maxBoxSize={3}
                columns={5}
                rows={3}
                shouldTileFlip={false}
                relaxed={true}
            />,
            this.node
        );
    }

    static appliesTo(state) {
        return !ScreenService.isVertical && _.get(state, 'state.layout') === 'relaxed' && HwFeatureService.isSupported('social');
    }
}

StateFactory.register('socialgrid', SocialGrid3SmallState, 1);

export default SocialGrid3SmallState;
